/**
 * Animated empty-state shown while recording is active but no facts have
 * been extracted yet (typically the first 25-30s of a session, before the
 * first STT flush + extraction round-trip completes).
 *
 * Visual reuses the MicDock language — concentric terra rings rippling
 * outward, soundwave bars pulsing in place — so the user reads the recording
 * surface as one continuous "we are listening" state rather than two
 * separate components. Pulse delays staggered so the bars don't move in
 * lockstep, which would feel mechanical.
 */
export default function ListeningIndicator({
  title = 'À l’écoute…',
  subtitle = 'Les faits apparaîtront au fil de la conversation.',
}) {
  return (
    <div className="rounded-lg border border-dashed border-line p-8 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center">
        <div className="relative flex items-center justify-center">
          {/* Two concentric rippling rings, second one delayed for a stagger. */}
          <span
            className="absolute -inset-3 rounded-full border-[1.5px] border-terra-500 opacity-30 animate-ripple"
          />
          <span
            className="absolute -inset-3 rounded-full border-[1.5px] border-terra-500 opacity-30 animate-ripple"
            style={{ animationDelay: '1s' }}
          />
          {/* Soundwave bars — pulse-soft on the central pair, the outer pair
              breathes a quarter cycle behind for a subtle live feel. */}
          <div className="flex h-[20px] items-end gap-[3px]">
            <span className="w-[3px] rounded-[1px] bg-ink animate-pulse-soft" style={{ height: '45%' }} />
            <span className="w-[3px] rounded-[1px] bg-ink animate-pulse-soft" style={{ height: '90%', animationDelay: '0.2s' }} />
            <span className="w-[3px] rounded-[1px] bg-ink animate-pulse-soft" style={{ height: '60%', animationDelay: '0.4s' }} />
            <span className="w-[3px] rounded-[1px] bg-ink animate-pulse-soft" style={{ height: '80%', animationDelay: '0.6s' }} />
          </div>
        </div>
      </div>
      <div className="text-[13px] font-medium text-ink">{title}</div>
      <div className="mt-1 text-[11.5px] text-muted">{subtitle}</div>
    </div>
  )
}
